import { api } from "services/api.service";
import { isAxiosError } from "utils/helpers";
import { redirect } from "react-router-dom";
import { withAuth } from "./utils/withAuth";

export const loader = withAuth(async () => {
  try {
    const { data } = await api.get("/current_user");
    return { user: data };
  } catch (e) {
    if (isAxiosError(e)) {
      if (e.response?.status === 401) return redirect("/login");
    }
    throw e;
  }
});
